import { render, staticRenderFns } from "./text.component.vue?vue&type=template&id=dbd2403c"
import script from "./text.component.vue?vue&type=script&lang=ts"
export * from "./text.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports